import React from 'react';
import './style.scss';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import clsx from 'clsx';

const ListingWithIconAndText = (props) => {
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="ListingWithIconAndText" />;
  const { items } = props?.fields;

  if (!items?.length) return null;

  return (
    <div className={clsx('listing-with-icon-and-text', 'add-margins', props?.params?.Styles)}>
      {items.map((item, index) => (
        <div key={index} className="lwiat-item">
          <div className="lwiat-item-icon-wrapper">
            <Image className="lwiat-item-icon" field={item.fields.icon} />
          </div>
          <div className="lwiat-item-desc">
            <Text field={item.fields.title} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListingWithIconAndText;
